import { useMessageGetter } from '@messageformat/react';
import { ReactElement } from 'react';
import styles from './GraphSpecs.module.scss';

interface GraphSpecsProps {
  investmentAmount: number;
  accountSavings?: number;
  profitExpected: number;
  investmentTime: number;
}

const GraphSpecs = ({
  investmentAmount,
  accountSavings,
  profitExpected,
  investmentTime,
}: GraphSpecsProps): ReactElement => {
  const getMessage = useMessageGetter('course2.part3.interest_example_graph');
  const elements = [
    [
      investmentAmount,
      getMessage('investment_amount'),
      getMessage('investment_amount_suffix'),
    ],
    [accountSavings, getMessage('account_savings'), getMessage('account_savings_suffix')],
    [
      profitExpected,
      getMessage('profit_expectation'),
      getMessage('profit_expectation_suffix'),
    ],
    [investmentTime, getMessage('investment_time'), getMessage('investment_time_suffix')],
  ].filter(([value]) => value !== undefined);
  return (
    <dl className={styles.container}>
      {elements.map(([value, parameter, suffix]) => (
        <div key={parameter} className={styles.parameterGroup}>
          <dt>{parameter}</dt>
          <dd>{`${value}${suffix}`}</dd>
        </div>
      ))}
    </dl>
  );
};

export default GraphSpecs;
